import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apikey = process.env.REACT_APP_API_KEY;

export const universityApi = createApi({
  reducerPath: "universityApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
      headers.set("apiKey", apikey);
      headers.set("Authorization", JSON.parse(localStorage.getItem("loginData")).token);
      return headers;
    },
  }),

  endpoints: (builder) => ({
    tagTypes: ["University", "universityDetails"],
    getschoolist: builder.query({
      query: (body) => ({
        url: `/admin/getSchoolList`,
        method: "POST",
        body,
      }),
      providesTags: ["University"],
    }),

    getuniversitydetails: builder.query({
      query: (body) => ({
        url: `/admin/getSchoolDetails`,
        method: "POST",
        body,
      }),
      providesTags: ["universityDetails"],
    }),

    adduniversity: builder.mutation({
      query: (body) => ({
        url: `/admin/addSchool`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["University"],
    }),

    edituniversity: builder.mutation({
      query: (body) => ({
        url: `/admin/editSchoolDetails`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["University", "universityDetails"],
    }),

    changeuniversityStatus: builder.mutation({
      query: (body) => ({
        url: "/admin/changeSchoolStatus",
        method: "POST",
        body,
      }),
      invalidatesTags: ["University", "universityDetails"],
    }),

    deleteuniversity: builder.mutation({
      query: (body) => ({
        url: "/admin/deleteSchool",
        method: "POST",
        body,
      }),
      invalidatesTags: ["University",  "universityDetails"],
    }),

    uploadmedia: builder.mutation({
      query: (body) => ({
        url: "/media/uploadMedia",
        method: "POST",
        body,
      }),
    }),

    changeSubscriptionRequired: builder.mutation({
      query: (body) => ({
        url: "/admin/changeSubscriptionRequired",
        method: "POST",
        body,
      }),
      invalidatesTags: ["University", "universityDetails"],
    }),


  }),
});

export const {
  useGetschoolistQuery,
  useGetuniversitydetailsQuery,
  useAdduniversityMutation,
  useEdituniversityMutation,
  useUploadmediaMutation,
  useChangeuniversityStatusMutation,
  useDeleteuniversityMutation,
  useChangeSubscriptionRequiredMutation,
} = universityApi;
